import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Amplify, Auth } from "aws-amplify";
import Spinner from "./components/ui/Spinner";
import { login, setUserType } from "./redux/userSlice";
import { appendAlert } from "./redux/alertSlice";
import axios from "axios";
import "./Login.css";
import { Helmet } from "react-helmet";
import { inRange } from "./utils/utils";
import Background from "./Background";

console.log("⭐️google login Amplify.configure");

const Login: React.FC = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const handleGoogleLogin = async () => {
    localStorage.setItem("isLogged", "true");
    localStorage.setItem("userType", "google");
    console.log("⭐️google login Amplify.configure");
    Amplify.configure({
      Auth: {
        region: process.env.REACT_APP_GOOGLE_COGNITO_REGION,
        userPoolId: process.env.REACT_APP_GOOGLE_COGNITO_USER_POOL_ID,
        userPoolWebClientId:
          process.env.REACT_APP_GOOGLE_COGNITO_USER_POOL_WEB_CLIENT_ID,
        oauth: {
          domain: process.env.REACT_APP_GOOGLE_COGNITO_DOMAIN,
          scope: ["openid"],
          redirectSignIn: process.env.REACT_APP_AUTH_REDIRECT_SIGN_IN,
          redirectSignOut: process.env.REACT_APP_AUTH_REDIRECT_SIGN_OUT,
          responseType: "code",
        },
      },
    });
    Auth.federatedSignIn();
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      // ローディング表示
      setIsLoading(true);

      // 入力したユーザーIDとパスワードを取得
      let userId = username;
      let pwd = password;

      try {
        // 社内サーバにアクセスして、パスワードを変換
        let apiUrl = process.env.REACT_APP_API_OKAYAMA_SERVER_ADDRESS;
        if (username.startsWith("05")) {
          apiUrl = process.env.REACT_APP_API_CHIBA_SERVER_ADDRESS;
        }
        const postData = {
          account_id: userId,
          pwd: pwd,
        };
        console.log(postData);
        // const response = await axios.post( apiUrl + `/auth/password-fetch`, postData);
        const response = await axios.post(apiUrl || "", postData);
        console.log(response.data);
        if (response.data.account_id !== userId) {
          dispatch(
            appendAlert({
              severity: "error",
              message: "ID または パスワードが間違っています。",
              displayTime: 5000,
            })
          );
          return;
        }

        if (response.data.pwd === "") {
          dispatch(
            appendAlert({
              severity: "error",
              message: "ID または パスワードが間違っています。",
              displayTime: 5000,
            })
          );
          return;
        }

        // レスポンスよりパスワードを置き換える
        pwd = response.data.pwd;
      } catch (error: any) {
        console.log("Error logging in", error);
        dispatch(
          appendAlert({
            severity: "error",
            message:
              "社内サーバへのアクセスでエラーが発生しました。" + error.message,
            displayTime: 5000,
          })
        );
        return;
      }

      dispatch(setUserType("congito"));
      Amplify.configure({
        Auth: {
          region: process.env.REACT_APP_AUTH_REGION,
          userPoolId: process.env.REACT_APP_AUTH_USER_POOL_ID,
          userPoolWebClientId:
            process.env.REACT_APP_AUTH_USER_POOL_WEB_CLIENT_ID,
          oauth: {
            scope: ["openid"],
            redirectSignIn: process.env.REACT_APP_AUTH_REDIRECT_SIGN_IN,
            redirectSignOut: process.env.REACT_APP_AUTH_REDIRECT_SIGN_OUT,
            responseType: "code",
          },
          identity_provider: "COGNITO",
        },
      });

      // ログイン処理
      await Auth.signIn(userId, pwd);
      dispatch(login());
    } catch (error) {
      console.log("Error logging in", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Process Flow Manager</title>
      </Helmet>
      <Background />
      <div className="login-app-logo">
        <div className="site">
          <img src="images/app-logo.png" width="56" height="56" alt="logo" />
        </div>
        <h1 className="title">
          <span className="full-text">Process Flow Manager</span>
          <span className="short-text">PFM</span>
        </h1>
      </div>
      <div className="login-container">
        <form className="login-form" onSubmit={handleSubmit}>
          <div className="login-id">
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="ID"
            />
          </div>
          <div className="login-password">
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="パスワード"
            />
          </div>
          <div className="login-button">
            <button type="submit">ログイン</button>
          </div>
        </form>
        <p>または</p>
        <div>
          <button className="google-login" onClick={() => handleGoogleLogin()}>
            <img src="images/g-logo.png" width="24" height="24" />
            Googleで続行
          </button>
        </div>
      </div>
      {isLoading && <Spinner />}
    </>
  );
};

export default Login;
